<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.APPOINTMENT_TYPE' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.APPOINTMENT_TYPE' | translate }}</h3>
        </div>
        <div class="col-lg-4">

        </div>
    </div>

    <form [formGroup]="appointmentForm">
        <div class="row m-t-20">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.APPOINTMENT_TYPE' | translate }}</mat-label>
                    <input matInput placeholder="Appointment Type" formControlName="name">
                    <mat-error *ngIf="appointmentForm.get('name')?.hasError('required') && 
                    (appointmentForm.get('name')?.dirty || appointmentForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="appointmentForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM100' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.BILL_CHARGE' | translate }}</mat-label>
                    <mat-select formControlName="billChargeId">
                        <mat-option (click)="addBillCharge()">
                            <span class="f-w-600 f-s-15">{{ 'LABEL.ADD_LABEL' | translate }} New {{ 'ENTITY.BILL_CHARGE'
                                | translate }}</span>
                        </mat-option>
                        @for (billcharge of listofBillCharge; track billcharge) {
                        <mat-option [value]="billcharge.id">
                            <span class="f-s-15">{{ billcharge.name }}</span>
                            <span class="charge-amount f-s-14 f-w-600 m-l-20">({{billcharge.childValue|
                                currency:'INR'}})</span>
                        </mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="appointmentForm.get('billChargeId')?.hasError('required') && 
                    (appointmentForm.get('billChargeId')?.dirty || appointmentForm.get('billChargeId')?.touched)">
                        {{ 'REQUIRED.SELECTED_VALUE' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8"></div>
            <div class="col-lg-4 d-flex justify-content-end">
                <button mat-stroked-button (click)="onCloseDialog()" class="m-l-4 m-r-5">{{ 'BUTTON.BTN_CLOSE' |
                    translate }}</button>
                <button mat-flat-button color="primary" class="m-r-5 m-l-4" (click)="onUpdateAppointmentType()"
                    *ngIf="isEdit" [disabled]="appointmentForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

                <button mat-flat-button color="primary" class="m-l-4" (click)="onSaveAppointmentType()"
                    [disabled]="appointmentForm.invalid" *ngIf="!isEdit">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            </div>
        </div>
    </form>
</div>